(() => {
  'use strict';

  if (window.__ttgStickyAtcLoaded) return;
  window.__ttgStickyAtcLoaded = true;

  function initStickyAtc() {
    const bar = document.getElementById('ttgStickyCart');
    if (!bar || bar.dataset.ttgBound === 'true') return;

    const productSingle = bar.parentElement?.querySelector('product-single') || document.querySelector('#main product-single');
    const proxy = bar.querySelector('.ttg-sticky-cart__button');
    const label = bar.querySelector('.ttg-sticky-cart__label');
    const price = bar.querySelector('.ttg-sticky-cart__price');

    if (!productSingle || !proxy || !label || !price) {
      bar.dataset.ttgVisible = 'false';
      return;
    }

    const nativeButton = productSingle.querySelector('product-form button[name="add"]');
    const nativeForm = nativeButton?.closest('form[id^="product-form-"]');

    if (!nativeButton || !nativeForm) {
      bar.dataset.ttgVisible = 'false';
      return;
    }

    bar.dataset.ttgBound = 'true';

    let nativeVisible = false;
    let scheduled = false;

    function getPriceText() {
      const id = nativeForm.id.replace(/^product-form-/, '');
      const container = document.getElementById(`price-${id}`);
      if (!container || container.hidden || container.classList.contains('visibility-hidden')) return '';
      return container.querySelector('.price__number .money, .money')?.textContent?.trim() || '';
    }

    function cartUiOpen() {
      return Boolean(
        document.querySelector(
          '.modal--cart:not([aria-hidden="true"]), #popup-cart-notification:not([aria-hidden="true"])'
        )
      );
    }

    function sync() {
      scheduled = false;

      const staged = nativeButton.querySelector('staged-action');
      const busy = Boolean(
        staged?.classList.contains('is-doing') ||
        staged?.classList.contains('is-done')
      );
      const unavailable =
        nativeButton.disabled ||
        nativeButton.getAttribute('aria-disabled') === 'true';

      proxy.disabled = busy || unavailable;
      proxy.setAttribute('aria-busy', String(busy));

      label.textContent =
        nativeButton.querySelector('staged-action-text')?.textContent?.trim() ||
        nativeButton.textContent?.trim() ||
        window.theme?.localize?.('ADD_TO_CART') ||
        '';

      const currentPrice = unavailable ? '' : getPriceText();
      price.textContent = currentPrice ? ` • ${currentPrice}` : '';

      const mobile = window.matchMedia('(max-width: 767px)').matches;
      const show = mobile && !nativeVisible && !cartUiOpen();

      bar.dataset.ttgVisible = String(show);
      bar.setAttribute('aria-hidden', String(!show));
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(sync);
    }

    const visibilityObserver = new IntersectionObserver(entries => {
      nativeVisible = Boolean(entries[0]?.isIntersecting);
      schedule();
    }, {
      root: null,
      threshold: 0.01
    });

    visibilityObserver.observe(nativeButton);

    proxy.addEventListener('click', () => {
      if (proxy.disabled) return;
      nativeButton.click();
      schedule();
    });

    const productObserver = new MutationObserver(schedule);
    productObserver.observe(productSingle, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'disabled', 'aria-disabled', 'hidden']
    });

    const dialogObserver = new MutationObserver(schedule);
    dialogObserver.observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden']
    });

    nativeForm.addEventListener('change', schedule);
    nativeForm.addEventListener('input', schedule);
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('pageshow', schedule);

    const rect = nativeButton.getBoundingClientRect();
    nativeVisible =
      rect.height > 0 &&
      rect.top < window.innerHeight &&
      rect.bottom > 0;

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc, { once: true });
  } else {
    initStickyAtc();
  }

  document.addEventListener('shopify:section:load', () => {
    window.setTimeout(initStickyAtc, 0);
  });
})();
